import React from "react";
import { layoutClasses, LayoutRoot } from "./styles";

const AuthLayout = ({ children }) => {
  return (
    <main>
      <LayoutRoot className={layoutClasses.root}>{children}</LayoutRoot>
    </main>
  );
};

export default AuthLayout;
